<template>
    <el-card class="contract-setting">
        <div class="board-chart flex flex-wrap">
            <div class="contract-chart-item" v-for="(item, index) in settings" :key="index">
                <div class="chart-figure">
                    <p class="text">{{ item.title }}</p>
                    <div v-if="item.takeEffectTime!==null">
                    <h3 class="contract-setting-title">{{ item.statusTrans }}</h3>
                    <h3 class="contract-setting-title">新合同条款生效日期：{{ item.takeEffectTime }}</h3>
                    </div>
                    <div v-else>
                        <h3 class="contract-setting-title">未设置</h3>
                    </div>
                    <template>
                        <el-button
                            type="primary"
                            icon="el-icon-plus"
                            @click="fetchSetting(item)"
                            class="edit-button">{{ $t('tooltip.edit') }}
                        </el-button>
<!--                        <el-button
                            type="success"
                            @click="fetchSetting(item)"
                            class="edit-button setting-button">{{ $t('tooltip.setting') }}
                        </el-button>-->
                    </template>
                </div>
            </div>
        </div>

        <div class="contract-setting-dialog">
            <!-- 编辑弹窗 -->
            <el-dialog class="contract-setting-edit" :title="editForm.title" :visible.sync="edit_visible">
                <el-form ref="edit" :model="editForm" :rules="rules" :status-icon="true" v-loading="form_loading">
                    <tinymce v-model="editForm.content" />
                </el-form>
                <div slot="footer" class="dialog-footer"  style="text-align:center">
                    <el-button slot="footer" @click="edit_visible = false">{{ $t('Common.close') }}</el-button>
                    <el-button type="primary" slot="footer" @click="showTimeDialog()">{{ $t('Common.save') }}</el-button>
                </div>
            </el-dialog>

            <!-- 设置弹窗 -->
            <el-dialog
                class="contract-setting-set"
                :title="`${settingForm.title}${$t('tooltip.setting')}`"
                :visible.sync="setting_visible">
                <el-form ref="setting"
                         style="max-height: 80vh;overflow: auto;"
                    :model="settingForm"
                    :rules="rules"
                    :status-icon="true"
                    v-loading="form_loading"
                    label-width="140px"
                    label-suffix=":"
                    label-position="right">
                    <div style="margin: 15px 0;font-weight: bold;">
                        {{$t('Contract.Desc.contentLabel')}}
                    </div>
                    <div style="max-width: 95%;">
                        <tinymce v-model="settingForm.content" />
                    </div>
                    <div style="margin: 15px 0;font-weight: bold;">
                        {{$t('Contract.Desc.settingsLabel')}}
                    </div>
                    <el-form-item :label="$t('Contract.Desc.title')">
                    </el-form-item>
                    <el-form-item :label="$t('Contract.Desc.title')">
                        <el-radio-group v-model="settingForm.settings.show_title">
                            <el-radio v-model="settingForm.settings.show_title" :label="0">{{ $t('Contract.Desc.hide') }}</el-radio>
                            <el-radio v-model="settingForm.settings.show_title" :label="1">{{ $t('Contract.Desc.default_show') }}</el-radio>
                            <el-radio v-model="settingForm.settings.show_title" :label="2">{{ $t('Contract.Desc.customize_show') }}</el-radio>
                        </el-radio-group>
                        <el-input class="ml-2" v-model="settingForm.customTitle" ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Contract.Desc.logo')">
                        <el-radio v-model="settingForm.settings.show_logo" :label="0">{{ $t('Contract.Desc.hide') }}</el-radio>
                        <el-radio v-model="settingForm.settings.show_logo" :label="1">{{ $t('Contract.Desc.show') }}</el-radio>
                    </el-form-item>
                    <el-form-item :label="$t('Contract.Desc.charter')">
                        <el-radio v-model="settingForm.settings.show_contract" :label="0">{{ $t('Contract.Desc.hide') }}</el-radio>
                        <el-radio v-model="settingForm.settings.show_contract" :label="1">{{ $t('Contract.Desc.show') }}</el-radio>
                    </el-form-item>
                    <el-form-item v-if="settingForm.title !== '定金合同条款'" :label="$t('Contract.type')">
                        <el-radio v-model="settingForm.settings.show_contract_type" :label="0">{{ $t('Contract.Desc.hide') }}</el-radio>
                        <el-radio v-model="settingForm.settings.show_contract_type" :label="1">{{ $t('Contract.Desc.show') }}</el-radio>
                    </el-form-item>
                    <el-form-item :label="$t('Client.club')">
                        <el-radio v-model="settingForm.settings.show_club" :label="0">{{ $t('Contract.Desc.hide') }}</el-radio>
                        <el-radio v-model="settingForm.settings.show_club" :label="1">{{ $t('Contract.Desc.show') }}</el-radio>
                    </el-form-item>
                    <el-form-item :label="$t('Contract.Desc.member')">
                        <el-radio v-model="settingForm.settings.show_sign_1" :label="0">{{ $t('Contract.Desc.hide') }}</el-radio>
                        <el-radio v-model="settingForm.settings.show_sign_1" :label="1">{{ $t('Contract.Desc.show') }}</el-radio>
                    </el-form-item>
                    <el-form-item :label="$t('Contract.Desc.club_sign')">
                        <el-radio v-model="settingForm.settings.show_sign_2" :label="0">{{ $t('Contract.Desc.hide') }}</el-radio>
                        <el-radio v-model="settingForm.settings.show_sign_2" :label="1">{{ $t('Contract.Desc.show') }}</el-radio>
                    </el-form-item>
                    <el-form-item v-if="settingForm.title !== '定金合同条款'" :label="$t('Charge.discounted_price')">
                        <el-radio v-model="settingForm.settings.show_discount" :label="0">{{ $t('Contract.Desc.hide') }}</el-radio>
                        <el-radio v-model="settingForm.settings.show_discount" :label="1">{{ $t('Contract.Desc.show') }}</el-radio>
                    </el-form-item>
                    <el-form-item :label="$t('Contract.Desc.top')">
                        <el-radio v-model="settingForm.settings.show_top_height" :label="0">{{ $t('Contract.Desc.default') }}</el-radio>
                        <el-radio v-model="settingForm.settings.show_top_height" :label="1">{{ $t('Contract.Desc.customize') }}</el-radio>
                        <el-input class="ml-2" v-model="settingForm.topHeight" type="number"></el-input><span> mm</span>
                    </el-form-item>
                    <el-form-item :label="$t('Contract.Desc.zoom')">
                        <el-input type="number" v-model="settingForm.scaling"></el-input><span> %</span>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer"  style="text-align:center">
                    <el-button
                        type="primary"
                        slot="footer"
                        @click="showTimeDialog"
                    >{{ $t('Common.save') }}</el-button>
                </div>
            </el-dialog>

            <el-dialog
                title="选择模板生效日期"
                :visible.sync="effectVisible"
                width="30%"
                :before-close="closeTimeDialog">
                <div>
                <span>选择日期：</span>
                <el-date-picker
                    v-model="settingForm.takeEffectTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
                <div>
                    *签约日期在此生效日期后的合同，均按照新模板内容生成
                </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="effectVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleSettingWithDate">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </el-card>
</template>

<script>
import { Dialog, RadioGroup, Radio,DatePicker } from 'element-ui';
import Tinymce from '@/components/base/Tinymce';

export default {
    props: ['activeName'],
    components: {
        ElDialog: Dialog,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        tinymce: Tinymce,
        ElDatePicker:DatePicker
    },
    data() {
        return {
            settings: [],
            form_loading: false,
            editForm: {
                content: '',
            },
            edit_visible: false,
            setting_visible: false,
            effectVisible: false,
            effectDate: null,
            title: '',
            settingForm: {
                takeEffectTime:null,
                settings: {
                    show_title: '',
                    show_logo: '',
                    show_contract: '',
                    show_contract_type: '',
                    show_club: '',
                    show_sign_1: '',
                    show_sign_2: '',
                    show_discount: '',
                    show_top_height: '',
                },
            },
            rules: {
                content: [
                    { required: true, message: this.$t('Message.empty_content'), trigger: 'blur' },
                ],
            },
            loading: false,
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
        };
    },
    computed: {},
    watch: {
        activeName(val) {
            if (val === 'contract') {
                this.fetchData();
            }
        },
        'edit_visible'(val) {
            if (!val) this.editForm.content = '';
        },
    },
    methods: {
        fetchData() {
            API.get('contract/setting/list').then(res => {
                this.settings = res;
            });
            // 将搜索信息传入index
            this.$emit('input', '');
        },
        // 获取合同内容
        fethContract(item) {
            this.editForm = {};
            API.get(`contract/setting/${item.id}`).then(res => {
                this.editForm = res;
                this.edit_visible = true;
            });
        },
        // 获取合同设置
        fetchSetting(item) {
            API.get(`contract/setting/${item.id}`).then(res => {
                this.settingForm = res;
                this.setting_visible = true;
            });
        },
        showTimeDialog(){
          this.effectVisible = true;
        },
        closeTimeDialog(){
            this.effectVisible = false;
        },
        // 编辑
        handleEdit() {
            API.put(`contract/setting/${this.editForm.id}/content`, this.editForm)
            .then(res => {
                if (res) $ele.$message.success(this.$t('Message.save'));
            })
            .finally(() => {
                this.form_loading = false;
                this.edit_visible = false;
                this.fetchData();
            })
            .catch(err => {
                $ele.$message.error(err);
            });
        },
        // 设置
        handleSetting() {
            if (this.settingForm.scaling < 58) return $ele.$message.warning(this.$t('Message.Minimum_scaling58%'));
            API.put(`contract/setting/${this.settingForm.id}/newsettings`, this.settingForm)
            .then(res => {
                if (res) $ele.$message.success(this.$t('Message.save'));
            })
            .finally(() => {
                this.form_loading = false;
                this.setting_visible = false;
                this.effectVisible = false;
                this.settingForm.takeEffectTime=null;
                this.fetchData();
            })
            .catch(err => {
                $ele.$message.error(err);
            });
        },
        handleSettingWithDate() {
            if (this.settingForm.takeEffectTime===null) return $ele.$message.warning(this.$t('Common.choose_date'));
            this.handleSetting();
        },
        handleReset() {
            this.form = {};
        },
    },
    created() {
        if (this.activeName === 'contract') this.fetchData();
    },
};
</script>
<style lang="scss">
.contract-setting {
    min-width: 1100px;
    .board-chart {
        width: 100%;
        height: auto;
    }
    .contract-chart-item {
        width: 20%;
        margin-right: 1%;
        background: #fff;
        float: left;
        min-width: 30%;
        border: 1px solid #e6e6e6;
        margin-top: 15px;
        padding: 50px 10px 30px 10px;
        text-align: center;
        &:first-child {
        margin-left: 0;
        }
    }
    .chart-figure {
        position: relative;
        line-height: 1.3;
        .text {
        font-size: 13px;
        font-weight: 400;
        color: #4c4c4c;
        margin-bottom: 15px;
        }
        .contract-setting-title {
        font-size: 14px;
        margin-bottom: 15px;
        color: #bfbfbf;
        }
    }
    .edit-button {
        display: inline-block;
        width: 100px;
        height: 32px;
        text-align: center;
        font-size: 13px;
        background: #05abef;
    }
    .setting-button {
        background: #3ead69;
    }
    .contract-setting-dialog {
        .el-radio__label {
            font-size: 12px;
        }
        .el-form-item__label {
            font-size: 12px;
        }
        .el-input {
            width: 180px;
        }
        .el-dialog__body {
            padding: 10px 20px;
        }
    }
    .contract-setting-edit {
        .el-dialog {
            width: 540px;
        }
        textarea {
            height: 196px;
            overflow-y: auto;
        }
    }
}
.contract-setting-set {
    .el-dialog {
        width: 720px;
    }
}
.mce-flow-layout,
.mce-content-body {
    display: none !important;
}
.mce-edit-area {
    border-width: 0 !important;
}
</style>
